export const environment = {
    production: false,
    apiUrl: 'https://esg-dev.fundepag.br/api/backend',
    storagePrefix: 'fundepagESGDev'
  };
  